import { render } from "./End.vue?vue&type=template&id=03153562&scoped=true&ts=true"
import script from "./End.vue?vue&type=script&lang=ts"
export * from "./End.vue?vue&type=script&lang=ts"

import "./End.vue?vue&type=style&index=0&id=03153562&lang=scss&scoped=true"

import exportComponent from "D:\\work\\h5\\2024sjAnswer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03153562"]])

export default __exports__